import { RightOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Input, PageHeader, Row, Select, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import accountService from "../../api/account.service";
import ProgrammeService from '../../api/programme.service'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import PaymentPaidList from '../../components/payment/PaymentPaidList'
import VoucherListView from "../../components/voucher/VoucherListView";
import { DATE_FORMAT_DMY_SLASH, SUCCESS_STATUS } from '../../utility/Constants'
import commonUtility from "../../utility/Utils";
const { Option } = Select;


const VoucherList = () => {
    const [form] = Form.useForm();
    const [accountList, setAccountList] = useState([]);
    const [selectedFromDate, setSelectedFromDate] = useState("");
    const [selectedEndDate, setSelectedEndDate] = useState("");
    const [selectedTranType, setSelectedTranType] = useState("");
    const [selectedAccountID, setSelectedAccountID] = useState("");

    const [voucherList, setVoucherList] = useState([]);
    const [voucherMasterData, setVoucherMasterData] = useState([]);
    const [voucherDetailData, setVoucherDetailData] = useState([]);

    const [isDataUpdated, setIsDataUpdated] = useState(false);



    const onAccountSelect = (value, event) => {

        const account_id = form.getFieldValue("account_id");
        setSelectedAccountID(account_id)

    };

    const onTransTypeSelect = () => {
        const tran_type = form.getFieldValue("tran_type");
        setSelectedTranType(tran_type)
    }


    const onFromDateChange = (date, dateString) => {
        // console.log(date, dateString);
        setSelectedFromDate(dateString)
        form.setFieldsValue({
            from_date : dateString
        });
    };

    const onEndDateChange = (date, dateString) => {
        // console.log(date, dateString);
        setSelectedEndDate(dateString)
        form.setFieldsValue({
            to_date : dateString
        });
        
    };


    const onVocherListSearch = async (values) =>  {
        setVoucherList([])
        setVoucherMasterData([])
        setVoucherDetailData([])
        

        const data = {
           // formdata:{ from_date:fromdate,to_date:enddate,account_id:accountid }
            formdata:{ from_date:selectedFromDate,to_date:selectedEndDate,tran_type:selectedTranType, account_id:selectedAccountID }
       }
       accountService.voucherList(data).then((res) => {
        console.log(res)
      
         if(commonUtility.sanitizeObject(res)) {
            const voucher_data = res.response_data;
            console.log(voucher_data)
            setVoucherList(voucher_data)
            setVoucherMasterData(voucher_data.masterData)
            setVoucherDetailData(voucher_data.detailsData)
         }
         setIsDataUpdated(!isDataUpdated)
        
         
       });
    }

    useEffect(() => {
        accountService.accountList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setAccountList(res.data.response_data);
            }

        });
    }, []);

    return (
        <div>


            <div className="inside-main-content">
                <AdminBreadCrumb />

                <div className="box-style">
                    <PageHeader
                        ghost={false}
                        onBack={() => window.history.back()}
                        title="Voucher List"
                        subTitle=""

                    ></PageHeader>

                    <div className="">

                        <div className="form-content">

                            <Row className="" style={{ background: "transparent" }}>
                                <Col className="" xs={24} xl={24}>
                                    <Form
                                        form={form}
                                        layout="vertical"
                                        onFinish={onVocherListSearch}
                                        autoComplete="off"
                                    // initialValues={formDefaultValues}
                                    >

                                        <Row gutter={20} style={{ margin: "0.5rem" }}>

                                            <Col xs={24} xl={5} >

                                                <Form.Item name="from_date_picker" label="From Date" rules={[
                                                    {
                                                        required: true,
                                                        message: 'Start date is required',
                                                    },
                                                ]}>
                                                    <DatePicker
                                                        format={DATE_FORMAT_DMY_SLASH}
                                                        onChange={onFromDateChange}
                                                        style={{ width: "100%" }}
                                                        inputReadOnly={true}
                                                    />
                                                </Form.Item>
                                                <Form.Item name="from_date" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={5} >

                                                <Form.Item name="to_date_picker" label="End Date" rules={[
                                                    {
                                                        required: true,
                                                        message: 'End date is required',
                                                    },
                                                ]}>
                                                    <DatePicker
                                                        format={DATE_FORMAT_DMY_SLASH}
                                                        onChange={onEndDateChange}
                                                        style={{ width: "100%" }}
                                                        inputReadOnly={true}
                                                    />
                                                </Form.Item>
                                                <Form.Item name="to_date" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>

                                            </Col>

                                            <Col xs={24} xl={5}>
                                                <Form.Item name="tran_type" label="Trans Type" >
                                                    <Select className="text-left" onSelect={onTransTypeSelect}> 

                                                    <Option key="" value="">Select</Option>
                                                    <Option key="RC" value="RC">Receipt</Option>
                                                    <Option key="PY" value="PY">Payment</Option>

                                                    </Select>
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={5}>
                                                <Form.Item name="account_id" label="Account" >
                                                    <Select className="text-left" defaultValue="0" onSelect={onAccountSelect}>
                                                    <Option key="" value="">Select</Option> 

                                                        {
                                                            accountList.length > 0 ?
                                                                accountList.map(account_data => (
                                                                    <Option key={account_data.id} value={account_data.id}>{account_data.account_name}</Option>

                                                                ))
                                                                : ''
                                                        }
                                                    </Select>
                                                </Form.Item>
                                            </Col>


                                            <Col xs={24} xl={3}>
                                                <Form.Item label=" ">
                                                    <Button
                                                        htmlType="submit"
                                                        shape="round"

                                                        className="custom-button-green"
                                                    >
                                                        Search <SearchOutlined />
                                                    </Button>
                                                </Form.Item>
                                            </Col>





                                        </Row>
                                    </Form>



                                </Col>
                            </Row>


                            <VoucherListView voucherListValue={voucherList} voucherMasterDataValue={voucherMasterData} voucherDetailDataValue={voucherDetailData} isDataUpdatedValue={isDataUpdated}/>


                        </div>
                    </div>

                </div>
            </div>

        </div>


    )
}

export default VoucherList